import { render, staticRenderFns } from "./EventReservation.vue?vue&type=template&id=f8cf4f56&"
import script from "./EventReservation.vue?vue&type=script&lang=js&"
export * from "./EventReservation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports